<!-- 编辑企业详情 -->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Head>
          <template v-slot:title>
            <span style="margin-left:30%;">企业-详情</span>
          </template>
        </Head>
      </el-col>
    </el-row>


    <el-row class="row-top" type="flex" justify="center">
      <el-col :span="15">
        <div>
          <el-card class="box-card set-card" style="position:relative;overflow: auto">
            <el-form :label-position="labelPosition" label-width="148px">
              <el-form-item label="公司LOGO" style="margin-top: 30px">
                <div v-if="detailData.logo">
                  <el-image
                      style="width:  255.53px;height: 170px;"
                      class="image"
                      :src="detailData.logo"
                      :preview-src-list="srcListImg">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </div>
                <div v-else>
                  暂无图片
                </div>
              </el-form-item>
              <el-form-item label="企业名称" style="margin-top: 30px">
                <el-input style="width: 800px" v-model="detailData.name" readonly="readonly"
                          class="inp text-bg define-inp"></el-input>
              </el-form-item>
              <el-form-item label="企业性质" style="margin-top: 30px">
                <el-input style="width: 800px" v-model="detailData.companyNature" readonly="readonly"
                          class="inp text-bg define-inp"></el-input>
              </el-form-item>
              <el-form-item label="企业行业" style="margin-top: 30px">
                <el-input style="width: 800px" v-model="detailData.industryName" readonly="readonly"
                          class="inp text-bg define-inp"></el-input>
              </el-form-item>
              <el-form-item label="人员规模" style="margin-top: 30px">
                <el-input style="width: 800px" v-model="detailData.personnelSize" readonly="readonly"
                          class="inp text-bg define-inp"></el-input>
              </el-form-item>
              <el-form-item label="公司所在地" style="margin-top: 30px">
                <el-input style="width: 800px" v-model="detailData.companyAddress" readonly="readonly"
                          class="inp text-bg define-inp"></el-input>
              </el-form-item>
              <el-form-item label="是否为名企" style="margin-top: 30px">
                <el-input style="width: 800px" v-model="namePas" readonly="readonly"
                          class="inp text-bg define-inp"></el-input>
              </el-form-item>
              <el-form-item label="是否为名企" style="margin-top: 30px">
                <el-switch v-model="switchvalue" active-color="#13ce66" inactive-color="#ff4949" @change="switchClick">
                </el-switch>
              </el-form-item>
              <el-form-item label="	企业营业执照" style="margin-top: 30px">
                <div v-if="detailData.approve">
                  <el-image
                      style="width:  255.53px;height: 170px;"
                      class="image"
                      :src="detailData.approve"
                      :preview-src-list="srcListApprove">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </div>
                <div v-else>暂无图片</div>

              </el-form-item>
            </el-form>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Head from '@/components/header/head.vue';

export default {
  name: "editqiye",
  components: {
    Head
  },
  data() {
    return {
      labelPosition: 'right',
      detailData: "",
      page: 1,
      size: 1,
      namePas: "",
      switchvalue: false,
      srcListImg: [],
      srcListApprove: [],
      approve: '',
      logo: '',
      roleId:"",
    }
  },
  created() {
    this.roleId = JSON.parse(sessionStorage.getItem("userInfo")).roleId;
    this.Valid = this.$route.query.parmas
    // this.Businessdetails(this.$route.params.id)
    // this.
  },
  mounted() {
    this.Businessdetails()
  },
  methods: {
    // 获取企业库详情
    Businessdetails(Valid) {
      this.axiosGet('/company/findById/' + this.Valid, {}).then((res) => {
        if (res.code == 200) {
          this.detailData = res.data
          this.srcListApprove.push(this.detailData.approve)
          this.srcListImg.push(this.detailData.logo)
          if (res.data.famousCompany == 0) {
            this.namePas = '不是'
            this.switchvalue = false
          } else {
            this.namePas = '是'
            this.switchvalue = true
          }
        }
      })
    },
    // 当前文件
    switchClick(val) {
      var h1
      if (val == true) {
        h1 = 1
      } else {
        h1 = 0
      }
      this.axiosPost('/company/update/famousCompany', {
        id: this.detailData.id,
        famousCompany: h1
      }).then((res) => {
        this.Businessdetails()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.define-inp .el-input__inner, .define-inp .el-textarea__inner {
  width: 800px !important;
}

</style>

